import { useState, useCallback } from "react";
import { useFormContext } from "react-hook-form";
import { fieldNames } from "../../Components/CreateJob/CreateJobView/BuildQuote/constant";

export const useSignatureState = () => {
  const { setValue } = useFormContext();
  const [signatureState, setSignatureState] = useState({
    url: null,
    type: null,
    textValue: null,
  });

  const updateSignature = useCallback(
    (
      url: string | null,
      type: string | null = null,
      textValue: string | null = null
    ) => {
      const newSignatureState = { url, type, textValue };
      setSignatureState(newSignatureState);

      setValue(fieldNames.SIGN_IMAGE_SRC, url);
      if (textValue) {
        setValue(fieldNames.SIGN_TEXT, textValue);
      }

      return newSignatureState;
    },
    [setValue]
  );

  return {
    signatureState,
    updateSignature,
    setSignatureState,
  };
};
